module.exports = __webpack_public_path__ + "static/img/72010B_6_R_20200731_fit.5ff7ccb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/72010B_6_R_20200731_fit.png
// module id = h33Q
// module chunks = 0